<script setup>
// Free Tools 首页枢纽 /free-tools/（nuxt#19 P2）。
import "@/assets/styles/free-tools.css";
definePageMeta({ layout: "free-tools" });
useHead({
  title: "Free Online Tools — Convert, Compress & Edit | SharkFoto",
  meta: [{ name: "description", content: "Free online tools to convert, compress and edit images, video, GIFs, audio, camera raw, vector and more — common formats in your browser, advanced ones on our secure servers, never stored. No sign-up, no watermark." }],
  link: [{ rel: "canonical", href: "https://sharkfoto.com/free-tools/" }],
  script: [{ type: "application/ld+json", innerHTML: JSON.stringify({ "@context": "https://schema.org", "@type": "CollectionPage", name: "Free Online Tools", description: "Convert, compress and edit images, video, GIFs, audio and more — free, processed securely and never stored.", url: "https://sharkfoto.com/free-tools/" }) }],
});
</script>

<template>
  <FreeToolsHub :crumb="[['Home', 'https://sharkfoto.com/'], ['Free Tools', '']]" />
</template>
